class SaveRainfallUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute({ FK_STATION, START, END, DATA }) {
    let station_rainfall = await this.repository.showRainfallByStationAndInterval({
      FK_STATION,
      START,
      END,
    });

    let formatted_rainfall = DATA.map((item) => {
      let [TIME, VALUE] = item;
      return { FK_STATION, TIME, VALUE };
    });

    if (station_rainfall.length) {
      for (let rainfall of formatted_rainfall) {
        let alreadyExists = station_rainfall.some(
          (item) => item.TIME == rainfall.TIME
        );
        if (alreadyExists) {
          continue;
        }
        station_rainfall.push(rainfall);
      }
    } else {
      station_rainfall = formatted_rainfall;
    }

    let row_values=``

    station_rainfall.forEach((row,index,rows)=>{
      let {
        FK_STATION,
        TIME,
        VALUE
      }=row

      row_values+= `(${FK_STATION},'${TIME}','${VALUE}')${index === rows.length - 1 ? "" : ","}`;
    })

    if (station_rainfall.length) {
      //Para não ter risco de apagar algo que o CRON já tinha feito anteriormente,
      // é necessário apagar só pelo o intervalo de tempo que foi recalculado a rainfall e et0
      await this.repository.deleteByInterval(FK_STATION,START,END);
    }

    return await this.repository.savePrevData(row_values);
  }
}
export {
  SaveRainfallUseCase
};
